export default __webpack_public_path__ + "static/media/bake-pro-logo.2682ea77.svg";